<div [formGroup]="docForm" class="container-panel">
  <div class="card-group header card-col">
    <div class="card">
      <div class="row row-cols-1 row-cols-md-6">
        <div class="col col-md-2">
          <label for="paymentTermId" class="form-label text-primary">
            {{ 'GoliathCore::PaymentTerm' | abpLocalization }}
          </label>
          <ng-select
            class="form-control"
            id="paymentTermId"
            formControlName="paymentTermId"
            bindLabel="code"
            bindValue="id"
            [items]="paymentTerms$ | async"
          >
            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
              <span [title]="item.name.current"> {{ item.name.current }} - {{ item.code }}</span>
            </ng-template>
          </ng-select>
        </div>
        @if (docRoleInput !== docRole.CustomerSubscription) {
          <div class="col col-md-2">
            <label for="invoiceTermId" class="form-label text-primary">
              {{ 'Contact::Customer:InvoiceTerm' | abpLocalization }}
            </label>
            <ng-select
              class="form-control"
              id="invoiceTermId"
              formControlName="invoiceTermId"
              bindLabel="code"
              bindValue="id"
              [items]="invoicingTerms$ | async | orderBy: 'order'"
            >
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <span [title]="item.name.current">{{ item.name.current }} - {{ item.code }}</span>
              </ng-template>
            </ng-select>
          </div>
        }
        <div class="col col-md-2">
          <label for="paymentMethodId" class="form-label text-primary">
            {{ 'GoliathCore::PaymentMethod' | abpLocalization }}
          </label>
          <ng-select
            class="form-control"
            id="paymentMethodId"
            formControlName="paymentMethodId"
            bindLabel="uniqueCode"
            bindValue="id"
            [loading]="paymentMethodTypeStore.loading()"
            [items]="paymentMethodTypeStore.entities()"
          >
            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
              <span [title]="item.name.current"
                >{{ item.uniqueCode }} - {{ item.name.current }}</span
              >
            </ng-template>
          </ng-select>
        </div>
        <div class="col col-md-2">
          <label for="financialDiscount" class="form-label text-primary">{{
            '::FinancialDiscount' | abpLocalization
          }}</label>
          <input
            id="financialDiscount"
            class="form-control"
            formControlName="financialDiscount"
            suffix="%"
            mask="percent.2"
          />
        </div>
        <div class="col col-md-2">
          <label for="financialDiscountDays" class="form-label text-primary">
            {{ '::FinancialDiscountDays' | abpLocalization }}
          </label>
          <input
            type="number"
            id="financialDiscountDays"
            min="0"
            mask="separator.0"
            class="form-control"
            formControlName="financialDiscountDays"
            [DwInput]
          />
        </div>
        @if (docForm.get('discount') != null) {
          <div class="col col-md-2">
            <label for="discount" class="form-label text-primary">{{
              '::GlobalDiscount' | abpLocalization
            }}</label>
            <input
              id="discount"
              class="form-control"
              formControlName="discount"
              suffix="%"
              mask="percent.2"
              [DwInput]="{ autocomplete: false }"
            />
          </div>
        }
      </div>
    </div>
  </div>
</div>
